class SkinmedicinePasswordReveal {
  constructor(button) {
    this.button = button;
    this.input = document.getElementById(button.getAttribute('aria-controls'));

    if (!this.input) return;

    this.button.addEventListener('click', () => this.toggle());
  }

  toggle() {
    const willReveal = this.input.type === 'password';

    this.input.type = willReveal ? 'text' : 'password';
    this.button.setAttribute('aria-pressed', String(willReveal));
    this.input.focus();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-password-reveal]').forEach((button) => {
    new SkinmedicinePasswordReveal(button);
  });
});
